import BaseComponent from 'foundation/base-component';
import eventBus from '../../../general/js/event-bus';

export default class FormFieldComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        if (!this.refs || !this.refs.native) {
            console.warn(`FormFieldComponent (id: ${this.id}) skipped initialization: 'native' ref is missing.`);
            return;
        }

        this.onChange = this.onChange.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);

        this.init();
    }

    static getRequiredRefs() {
        return ['native'];
    }

    init() {
        eventBus.addListener('hide-form-field-tooltip', this.hideFormFieldTooltip.bind(this));
        this.addListeners();
        this.checkFill();
    }

    addListeners() {
        this.addListener(this.refs.native, 'change', this.onChange);
        this.addListener(this.refs.native, 'focus', this.onFocus);
        this.addListener(this.refs.native, 'blur', this.onBlur);
    }

    onChange() {
        this.checkFill();
    }

    onFocus() {
        this.element.classList.add('is-focused');
        this.element.classList.add('is-placeholder-visible');

        if (!this.refs.tooltip || this.element.classList.contains('is-invalid')) {
            return false;
        }

        this.refs.tooltip.classList.remove('is-hidden');
    }

    onBlur() {
        this.element.classList.remove('is-focused');
        this.element.classList.remove('is-placeholder-visible');
        this.checkFill();

        if (this.refs.tooltip) {
            this.refs.tooltip.classList.add('is-hidden');
        }
    }

    checkFill() {
        if (!this.refs.native) return;

        const isRadio = this.refs.native.type === 'radio';

        const isEmpty = isRadio ?
            !this.element.querySelector('input[name="' + this.refs.native.name + '"]:checked') :
            this.refs.native.value === '';

        if (isEmpty) {
            this.element.classList.remove('is-filled');
            this.element.classList.add('is-empty');
        } else {
            this.element.classList.add('is-filled');
            this.element.classList.remove('is-empty');
        }
    }

    hideFormFieldTooltip() {
        if (!this.refs.tooltip) return false;
        this.refs.tooltip.classList.add('is-hidden');
    }
}
